<script lang="ts">
    import debounce from "debounce";
    import { createEventDispatcher } from "svelte";

    import ButtonWithIcon from "@components/Buttons/ButtonWithIcon.svelte";
    import Icon from "@components/Icon.svelte";
    import DecreaseIcon from "@components/icons/DecreaseIcon.svelte";
    import IncreaseIcon from "@components/icons/IncreaseIcon.svelte";

    export let quantity: number;
    export let disabled = false;

    const dispatch = createEventDispatcher<{
        quantityChange: { quantity: number };
    }>();

    $: currentQuantity = quantity;

    const debouncedDispatch = debounce((newQuantity: number) => {
        dispatch("quantityChange", { quantity: newQuantity });
    }, 500);

    function handleDecrease() {
        if (currentQuantity <= 1 || disabled) return;
        currentQuantity = currentQuantity - 1;
        debouncedDispatch(currentQuantity);
    }

    function handleIncrease() {
        if (disabled) return;
        currentQuantity = currentQuantity + 1;
        debouncedDispatch(currentQuantity);
    }
</script>

<div class="gw-wl-item-quantity-change">
    <ButtonWithIcon
        class="gw-wl-item-quantity-change__button"
        ariaLabel="Decrease quantity"
        disabled={currentQuantity <= 1 || disabled}
        on:click={handleDecrease}
    >
        <Icon width={20} height={20} viewBox="0 0 24 24">
            <DecreaseIcon />
        </Icon>
    </ButtonWithIcon>
    <span class="gw-wl-item-quantity-change__value">
        {currentQuantity}
    </span>
    <ButtonWithIcon
        class="gw-wl-item-quantity-change__button"
        ariaLabel="Increase quantity"
        {disabled}
        on:click={handleIncrease}
    >
        <Icon width={20} height={20} viewBox="0 0 24 24">
            <IncreaseIcon />
        </Icon>
    </ButtonWithIcon>
</div>

<style lang="postcss">
    .gw-wl-item-quantity-change {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.5em;
        border: 1px solid rgba(38, 40, 66, 0.12);
        border-radius: 4px;
        padding: 4px;

        &__value {
            font-weight: 500;
            font-size: 0.8em;
        }
    }

    :global(.gw-wl-item-quantity-change__button) {
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        border-radius: 4px;
        background-color: transparent;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover:not(:disabled) {
            background-color: #f6f8fa;
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }
</style>
